import React from 'react'
import styled from 'styled-components'
import { Set } from 'immutable'

import { body } from 'styles/texts'
import { primary, borderColor, white, gray } from 'styles/colors'

import X from 'components/icons/X'
import { InputWithSuggestions } from 'components/form'

const Wrapper = styled.div`
  width: 100%;
`

const RolesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -5px;
  margin-top: 5px;
`

const Role = styled.div`
  margin: 5px;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  font-size: 14px;
  padding: 6px 10px;
  display: flex;
  align-items: center;
`

const Text = styled.div`
  margin-right: 8px;
`

const InputGroup = styled.div`
  display: flex;
  width: 100%;
`

const Button = styled.button`
  margin-left: 5px;
  flex-shrink: 0;
  padding: 0;
  width: 40px;
  height: 40px;
  background-color: ${primary};
  border: 1px solid ${primary};
  border-radius: 4px;

  &:disabled {
    background-color: ${white};
    border-color: ${borderColor};
  }
`

const HelpText = styled.div`
  ${body};
  color: ${gray};
`

class RolesInput extends React.Component {
  state = {
    input: '',
  }

  addRoles = role => {
    let roles = role.split(',').map(s => s.trim());
    this.props.onChange(Set([...this.props.value, ...roles]).toArray())
    this.setState({ input: '' })
  }

  componentWillUnmount() {
    if (this.state.input.trim() !== "") {
      this.addRoles(this.state.input);
    }
  }

  removeRole = role => {
    this.props.onChange(
      Set(this.props.value)
        .remove(role)
        .toArray()
    )
  }

  render() {
    return (
      <Wrapper>
        <InputGroup>
          <InputWithSuggestions
            suggestionsType="role"
            placeholder="F.eks. Gå med avisen, Levere ut Pizza, Ta bilder, Klippe Plen"
            value={this.state.input}
            onChange={e => this.setState({ input: e.target.value })}
            select={role => role && this.addRoles(role)}
            exclusions={this.props.value}
          />
          <Button
            type="button"
            disabled={!this.state.input.length}
            onClick={() => this.addRoles(this.state.input)}
            style={{color : !this.state.input.length ? borderColor : white}}>
            Legg til
          </Button>
        </InputGroup>
        {this.props.helpText && <HelpText>{this.props.helpText}</HelpText>}
        <RolesList>
          {this.props.value.map(role => (
            <Role key={role}>
              <Text>{role}</Text>
              <X onClick={() => this.removeRole(role)} />
            </Role>
          ))}
        </RolesList>
      </Wrapper>
    )
  }
}

export default RolesInput



// WEBPACK FOOTER //
// ./src/components/form/RolesInput.js